import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { categories, articles } from '@/mocks/data';
import ArticleCard from '@/components/feature/ArticleCard';
import Breadcrumb from '@/components/feature/Breadcrumb';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const currentCategory = categories.find((c) => c.slug === slug) || categories[0];

  const [activeSlug, setActiveSlug] = useState(slug || categories[0].slug);

  useEffect(() => {
    if (slug) setActiveSlug(slug);
  }, [slug]);

  const filteredArticles = articles.filter((a) => a.categorySlug === activeSlug);

  const categoryJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: `${currentCategory.name} - 里番动漫分类浏览`,
    description: currentCategory.description,
    url: `https://yozakura-nav.example.com/category/${activeSlug}`,
    mainEntity: {
      '@type': 'ItemList',
      itemListElement: filteredArticles.map((a, i) => ({
        '@type': 'ListItem',
        position: i + 1,
        url: `https://yozakura-nav.example.com/article/${a.slug}`,
      })),
    },
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(categoryJsonLd) }}
      />
      <main className="pt-16">
        <Breadcrumb
          items={[
            { label: '首页', href: '/' },
            { label: '分类浏览', href: '/category/pure-love' },
            { label: currentCategory.name },
          ]}
        />

        <section className="w-full px-4 md:px-6 lg:px-8 py-8 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <h1 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-2">
              {currentCategory.name}
            </h1>
            <p className="text-sm text-foreground-500 max-w-2xl mb-8">
              {currentCategory.description}
            </p>

            <div className="flex items-center gap-2 mb-10 overflow-x-auto pb-2 flex-wrap">
              {categories.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap ${
                    activeSlug === cat.slug
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-50 text-foreground-600 border border-background-200/70 hover:border-primary-300 hover:text-primary-500'
                  }`}
                >
                  <i className={`${cat.icon} text-xs`}></i>
                  {cat.name}
                </Link>
              ))}
            </div>

            {filteredArticles.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {filteredArticles.map((article) => (
                  <ArticleCard key={article.id} {...article} />
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-secondary-100">
                  <i className="ri-inbox-line text-2xl text-secondary-500"></i>
                </div>
                <p className="text-foreground-500">该分类暂无文章</p>
              </div>
            )}
          </div>
        </section>
      </main>
    </>
  );
}